import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseMutationResult } from '@tanstack/react-query'
import { NotificationRequestModel } from '../models/notifications.model'
import { usePortalMutation } from 'src/Libs/api'

import { updateNotification } from '../api'

interface UseNotificationUpdatingParams {
  onSuccess?: (vars: MutateNotifationsData) => void
  onError?: (vars: MutateNotifationsData) => void
}

interface MutateNotifationsData {
  id: number
  data: Partial<NotificationRequestModel>
}

type UseNotificationUpdatingReturnType = (data: UseNotificationUpdatingParams) => UseMutationResult<null, unknown, MutateNotifationsData>

/**
 * Custom hook to mutate existing notification records
 */
const useNotificationUpdating: UseNotificationUpdatingReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResult()

  const mutateNotificationConfig = usePortalMutation({
    mutationFn: (vars: MutateNotifationsData) => updateNotification(vars.id, vars.data, authFetch),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })

  return mutateNotificationConfig
}

export default useNotificationUpdating
